import { Controller } from "@hotwired/stimulus"

// eslint-disable-next-line import/no-default-export
export default class extends Controller {
  static targets = ["textarea", "submitButton"]

  updatePlaceholder(event) {
    const type = event.target.value
    if (type === "Task") {
      this.textareaTarget.placeholder =
        'Add your Task, for example "begin Menpur stims," here...'
    } else {
      this.textareaTarget.placeholder =
        'Add your Tip, for example "take prenatal vitamins daily," here...'
    }
  }

  validateForm() {
    const hasContent = this.textareaTarget.value.trim().length > 0
    this.submitButtonTarget.disabled = !hasContent
  }

  resetForm() {
    this.element.reset()
    this.submitButtonTarget.disabled = true
  }
}
